'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONTEXT_EMITTER = exports.CONTEXT_EMITTER = '@@es::emitter';
var CONTEXT_COMPONENT_PATH = exports.CONTEXT_COMPONENT_PATH = '@@es::comp-path';
var COMPONENT_PATH_DELIM = exports.COMPONENT_PATH_DELIM = ':_:';
var COMPONENT_TRACE_DELIM = exports.COMPONENT_TRACE_DELIM = ' -> ';
var LAYERS = exports.LAYERS = {
  DEFAULT: 'DEFAULT',
  PROPS: 'PROPS',
  PROVIDER: 'PROVIDER'
};
var LAYER_PRIORITY = exports.LAYER_PRIORITY = [LAYERS.DEFAULT, LAYERS.PROVIDER, LAYERS.PROPS];